on("change", "[data-autosubmit]", function () {
	if ($(this).attr("form")) {
		var form_id = $(this).attr("form");
		var form = document.getElementById(form_id);
	} else {
		var form = $(this).closest("form")[0];
	}

	form.requestSubmit();
});
